module.exports = __webpack_public_path__ + "img/074.5bb2138f.jpg";